import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppHomePageComponent } from '../app-home-page/app-home-page.component';
@Component({
  selector: 'meu-app-home-page-modal-notify',
  templateUrl: './app-home-page-modal-notify.component.html',
  styleUrls: ['./app-home-page-modal-notify.component.scss'],
})
export class AppHomePageModalNotifyComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AppHomePageComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close({ event: false });
  }
}
